import React from 'react';
import PropTypes from 'prop-types';
import './MessageBox.css';

function MessageBox({ displayedItems, mediaType, resultCount, searchTerm, error }) {
  const resultsExist = Boolean(resultCount);

  // temporary hack until someone fixes the intermittent disappearance of x-total-search-result-count
  if (isNaN(resultCount)) {
    return null;
  }

  const message = resultsExist ?
    <h2 id="top-of-results">
      Results <strong>{displayedItems}</strong> of about <strong>{resultCount}</strong> for <strong>{searchTerm}</strong>.
    </h2> :

    error ? 
      <h2>
        An error occured and your search could not be performed. Please try again later.
      </h2> :

      <div className="no-results">
        <br />
          Your search - <strong>{searchTerm}</strong> - did not match any documents.
          <br />
          No pages were found containing <strong>"{searchTerm}"</strong>.
          <br /><br />
          Suggestions:
          
          <ul>
             <li>Make sure all words are spelled correctly.</li>
             <li>Try different keywords.</li>
             <li>Try more general keywords.</li>
          </ul>
       </div>;

  return <div className="messageBox">{message || "Please submit a search query to view search results from CBC.ca"}</div>;
}

export default MessageBox;

MessageBox.propTypes = {
  displayedItems: PropTypes.string.isRequired,
  mediaType: PropTypes.string.isRequired,
  resultCount: PropTypes.number.isRequired,
  searchTerm: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/MessageBox.js